// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "6c0279586fdad77e8dde888e44264dec57134261/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};